import { isFunctionalityAllowed as ifa } from '../../facade/restrictions/restrictions';
import { instance as CompanyFactory } from '../../factory/company';

import DefaultEditorModeManager from './default';

class RestrictEditorModeManager extends DefaultEditorModeManager {
  constructor () {
    super();
    this.type = 'restrict';
    this.userMembership = null;

    this.hideList = [
      'header button[data-action="resize"]'
    ];
  }

  async loadFeatures () {
    if (!INKIVE.CompanyFactory) {
      await new Promise(resolve => {
        INKIVE.EditorFacade.on('editor.loaded', resolve);
      });
    }

    return await Promise.all([
      INKIVE.CompanyFactory.getCompanyItems('features'),
      INKIVE.UserInfoFactory.getMembership()
    ]).then(([features, membership]) => {
      this.userMembership = membership;
      this.features = features;

      return { features, membership };
    });
  }

  async enableUI () {
    super.enableUI();

    const { features, membership } = await this.loadFeatures();

    $('.tool-menu a[role="tab"][href="#tabImport"]').parent().hide();

    $('.tool-menu a[role="tab"][href="#tabAdmin"]').parent().hide();
    $('.tool-menu a[role="tab"][href="#tabLayouts"]').parent().hide();
    ifa('text_add') || $('.tool-menu a[role="tab"][href="#tabText"]').parent().hide();

    ifa('function_download_file') || $('#shr-buttons > [data-id="download"]').hide();
    ifa('function_print_file') || $('#shr-buttons > .print').hide();
    ifa('function_share_file') || $('#shr-buttons > [data-id="share"]').hide();

    if (!ifa('function_add_page')) {
      $('#pages-panel .add-new-page-wrapper').addClass('.disable');
    }

    if (!ifa('function_change_page_order')) {
      $('#pages-panel .content-items-list').addClass('.sortable-disabled');
    }

    !ifa('function_draw') &&
      !ifa('function_use_desygner_background') &&
      (!ifa('function_use_desygner_images') || !ifa('image_add')) &&
      (!ifa('function_use_desygner_vector') || !ifa('vector_add')) &&
      $('.tool-menu a[role="tab"][href="#tabExtra"]').parent().hide();

    !ifa('text_add') &&
      !(ifa('image_add') && ifa('function_use_asset_images')) &&
      !(ifa('image_add') && ifa('function_use_asset_logo')) &&
      !ifa('function_use_asset_colors') &&
      $('.tool-menu a[role="tab"][href="#tabLibrary"]').parent().hide();

    if (
      !ifa('function_use_own_images') &&
      !ifa('function_use_desygner_background') &&
      (!features.white_label.includes('show_marketplace') || !ifa('function_use_web_images')) &&
      (!ifa('image_add') || !membership?.permissions?.assets_view)
    ) {
      $('.tool-menu a[role="tab"][href="#tabImages"]').parent().hide();
    }

    !ifa('video_add') &&
      $('.tool-menu a[role="tab"][href="#tabVideo"]').parent().hide();

    !(ifa('logo_add') && ifa('function_use_asset_logo')) &&
      $('.tool-menu a[role="tab"][href="#tabLogos"]').parent().hide();

    !ifa('icon_add') && !ifa('function_use_desygner_vector') &&
      $('.tool-menu a[role="tab"][href="#tabIcons"]').parent().hide();

    !ifa('qrcode_add') &&
      $('.tool-menu a[role="tab"][href="#tabQRCode"]').parent().hide();

    !ifa('function_animation_file') &&
      $('.tool-menu a[role="tab"][href="#tabAnimation"]').parent().hide();

    $('#tabSearch a[data-id="layout"]').parent().addClass('hidden');

    (!ifa('function_use_web_vector') || !ifa('function_use_desygner_vector')) &&
      $('#tabSearch a[data-id="sticker"]').parent().addClass('hidden');

    (!ifa('function_use_web_background') || !ifa('function_use_desygner_background')) &&
      $('#tabSearch a[data-id="background"]').parent().addClass('hidden');

    (ifa('function_use_web_images') && ifa('image_add')) || $('#tabSearch a[data-id="image"]')
      .parent().addClass('hidden').siblings('li:not(.hidden)').first().find('a').trigger('click');

    (!ifa('function_use_web_images') || !$('#tabSearch li:not(.hidden)').length) &&
      $('.tool-menu a[role="tab"][href="#tabSearch"]').parent().hide();

    !ifa('image_add') && !ifa('image_content') && !ifa('text_add') &&
      $('.tool-menu a[role="tab"][href="#tabKWLS"]').parent().hide() &&
      $('.tool-menu a[role="tab"][href="#tabMLS"]').parent().hide();
  }

  disableUI () {
    super.disableUI();

    $('.tool-menu a[role="tab"][href="#tabAdmin"]').parent().show();
    $('.tool-menu a[role="tab"][href="#tabLayouts"]').parent().show();
  }

  async afterUIEnable (data) {
    await CompanyFactory.get(['designs', INKIVE.C.BOOK.encodedId]);

    if (ifa('function_add_page') || ifa('function_change_page_order')) {
      $('.tool-menu a[role="tab"][href="#tabLayouts"]').parent().show();
    }
  }
}

module.exports = RestrictEditorModeManager;
